import type { BeautyPlanPrices } from "../../types/pricing";
import type { BeautyPlan } from "../../features/beauty/beauty.types";
import {
  formatCurrencyBRL,
  getAnnualPlanSavings,
  getAnnualPlanTotal,
  getMonthlyEquivalentPrice
} from "../../constants/pricing";

type PlanCardProps = {
  plan: BeautyPlan;
  prices: BeautyPlanPrices;
  isAnnual: boolean;
};

function displayMonthlyEquivalent(monthlyPrice: number, isAnnual: boolean) {
  return formatCurrencyBRL(getMonthlyEquivalentPrice(monthlyPrice, isAnnual));
}

export function PlanCard({ plan, prices, isAnnual }: PlanCardProps) {
  const monthlyPrice = prices[plan.priceKey];
  const [priceMain, priceCents] = displayMonthlyEquivalent(monthlyPrice, isAnnual).split(",");
  const periodLabel = isAnnual ? "/mês eq." : "/mês";
  const cardClass = ["plano-card", plan.variant].filter(Boolean).join(" ");
  const badgeClass = `plano-badge${plan.variant === "upcoming" ? " muted" : ""}`;
  const ctaClass = `btn-plano ${plan.cta.variant}`;

  return (
    <article className={cardClass}>
      {plan.badge && <div className={badgeClass}>{plan.badge}</div>}
      <div className="plano-head">
        <div className="plano-name">{plan.name}</div>
        <div className="plano-target">{plan.target}</div>
        <div className="plano-price">
          <span className="plano-brl">R$</span>
          <span className="plano-val">{priceMain}</span>
          <span className="plano-period">,{priceCents}{periodLabel}</span>
        </div>
        <PlanBillingNote plan={plan} monthlyPrice={monthlyPrice} isAnnual={isAnnual} />
      </div>
      <div className="plano-body">
        <ul className="plano-feats">
          {plan.features.map((feature) => (
            <li className={feature.dimmed ? "dim" : undefined} key={feature.label}>
              {feature.label}
            </li>
          ))}
        </ul>
        <a className={ctaClass} href={plan.cta.href}>{plan.cta.label}</a>
      </div>
    </article>
  );
}

function PlanBillingNote({
  plan,
  monthlyPrice,
  isAnnual
}: {
  plan: BeautyPlan;
  monthlyPrice: number;
  isAnnual: boolean;
}) {
  if (plan.annualNote === "standard") {
    return (
      <div className={`plano-annual${isAnnual ? "" : " hidden"}`}>
        R$ {getAnnualPlanTotal(monthlyPrice).toLocaleString("pt-BR")}/ano cobrados uma vez, economia de R$ {getAnnualPlanSavings(monthlyPrice).toLocaleString("pt-BR")}
      </div>
    );
  }

  return (
    <div className="plano-annual muted">
      {isAnnual
        ? `R$ ${getAnnualPlanTotal(monthlyPrice).toLocaleString("pt-BR")}/ano cobrados uma vez, economia de R$ ${getAnnualPlanSavings(monthlyPrice).toLocaleString("pt-BR")}`
        : plan.monthlyNote}
    </div>
  );
}
